import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import { router } from "./router";
import store from "./store/index";
import locale from "element-ui/lib/locale/lang/en";
import VueQRCodeComponent from "vue-qrcode-component";
//---
import JsonExcel from "vue-json-excel";
import VueAnalytics from 'vue-analytics';

/**
 * Add library element.eleme.io
 */
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./element-variables.css";

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(VueAnalytics, {
  id: 'UA-166229736-1',
  router,
  autoTracking: {
    page: true
  }
})
Vue.component("qr-code", VueQRCodeComponent);
Vue.component("downloadExcel", JsonExcel);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
